import React from 'react';

const PricingSection = () => {
  return (
    <>
      {/* ---------- HAIRCUTS & STYLING ---------- */}
      <section className="py-8 sm:py-12 md:py-16 lg:py-20 bg-[#F4F4F4]">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 max-w-7xl">

          {/* HEADER */}
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-wider font-[Montserrat] mb-4">
              Haircuts & Styling
            </h2>
            <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed font-[Montserrat]">
              To provide the highest level of artistry, not all stylists offer every service. Please review your
              stylist's portfolio to ensure they provide the service you're looking for.
            </p>
            <p className="text-sm text-[#C7A064] font-[Montserrat] mt-2">
              Pricing varies based on length and thickness of your hair.
            </p>
          </div>

          {/* GRID */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-x-16 xl:gap-x-24">

            {/* ---- Haircut Women ---- */}
            <div>
              <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-6 text-center lg:text-left">
                Haircut Women
              </h3>

              {[
                { title: 'Artistic Director', price: '$150+' },
                { title: 'Senior Elite Stylist', price: '$125+' },
                { title: 'Elite Stylist', price: '$90-95' },
                { title: 'Master Stylist', price: '$70+' },
                { title: 'Stylist', price: '$60+' },
              ].map((item, i) => (
                <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
                  <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
                  <div className="flex-1 h-px bg-gray-300"></div>
                  <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
                </div>
              ))}

              {/* Wash + Blowout */}
              <h3 className="text-lg font-bold uppercase font-[Montserrat] mt-10 mb-6 text-center lg:text-left">
                Wash + Blowout
              </h3>

              {[
                { title: 'Artistic Director', price: '$90+' },
                { title: 'Senior Elite Stylist', price: '$80+' },
                { title: 'Elite Stylist', price: '$60+' },
                { title: 'Master Stylist', price: '$55+' },
                { title: 'Stylist', price: '$40+' },
              ].map((item, i) => (
                <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
                  <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
                  <div className="flex-1 h-px bg-gray-300"></div>
                  <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
                </div>
              ))}
            </div>

            {/* ---- Haircut Men ---- */}
            <div>
              <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-6 text-center lg:text-left">
                Haircut Men
              </h3>

              {[
                { title: 'Artistic Director', price: '$60+' },
                { title: 'Senior Elite Stylist', price: 'N/A', gray: true },
                { title: 'Elite Stylist', price: 'N/A', gray: true },
                { title: 'Master Stylist', price: 'N/A' },
                { title: 'Stylist', price: 'N/A', gray: true },
              ].map((item, i) => (
                <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
                  <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
                  <div className="flex-1 h-px bg-gray-300"></div>
                  <span className={`text-xs sm:text-sm font-[Montserrat] ${item.gray ? 'text-[#C7A064]' : 'text-[#C7A064]'}`}>
                    {item.price}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* NOTE */}
          <div className="mt-10 text-center">
            <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat]">
              To provide the highest level of artistry, not all stylists offer every service. Please review your stylist's portfolio before booking.
            </p>
          </div>
        </div>
      </section>

     {/* ---------- COLOR SERVICES ---------- */}
{/* ---------- COLOR SERVICES ---------- */}
<section className="py-8 sm:py-12 md:py-16 lg:py-20 bg-white">
  <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 max-w-7xl">
    {/* HEADER */}
    <div className="text-center mb-10">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-wider font-[Montserrat] mb-4">
        Color Services
      </h2>
      <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed font-[Montserrat] mb-4">
        Color is where our story began, and it remains our signature. We proudly carry Goldwell,
        Redken, Wella, Pravana, Joico, and Pulp Riot. All color services include a Blow-dry and Style.
      </p>
      <p className="text-sm text-[#C7A064] font-[Montserrat] normal">
        Pricing varies based on length and thickness of your hair.
      </p>
    </div>

    {/* GRID */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-x-16 xl:gap-x-24">
      
      {/* GOLDWELL COLOR TOUCHUP */}
      <div>
        <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-6 text-left">
          Goldwell Color Touchup
        </h3>
        {[
          { title: 'Artistic Director', price: '$160+' },
          { title: 'Senior Elite Stylist', price: '$140+' },
          { title: 'Elite Stylist', price: '$130+' },
          { title: 'Master Stylist', price: '$125+' },
          { title: 'Stylist', price: '$120+' },
        ].map((item, i) => (
          <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
            <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
            <div className="flex-1 h-px bg-gray-300"></div>
            <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
          </div>
        ))}
      </div>

      {/* GOLDWELL COLOR TRANSFORMATION | FULL COLOR */}
      <div>
        <h3 className="text-base sm:text-lg font-bold uppercase font-[Montserrat] mb-6 text-left">
          Goldwell Color Transformation / Full Color
        </h3>
        {[
          { title: 'Artistic Director', price: '$250+' },
          { title: 'Senior Elite Stylist', price: '$240+' },
          { title: 'Elite Stylist', price: '$230+' },
          { title: 'Master Stylist', price: '$225+' },
          { title: 'Stylist', price: '$220+' },
        ].map((item, i) => (
          <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
            <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
            <div className="flex-1 h-px bg-gray-300"></div>
            <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
          </div>
        ))}
      </div>

      {/* CLASSIC HIGHLIGHT / BALAYAGE */}
      <div className="mt-8 lg:mt-10">
        <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-3 text-left">
          Classic Highlight / Balayage
        </h3>
        <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat] mb-4 text-left">
          <span className="font-semibold">Classic Highlight / Balayage</span> include foils to create a lightened effect throughout your hair. This service
          also includes <span className="font-semibold">B3 Bond Builder</span> in your formula, a <span className="font-semibold">Glaze</span>, and a <span className="font-semibold">Blow-dry</span>. It's a timeless classic look. If
          you're looking for MAXIMUM COLOR CHANGE, please see our Luxe Highlight / Balayage option.
        </p>
        {[
          { title: 'Artistic Director', price: '$350+' },
          { title: 'Senior Elite Stylist', price: '$325+' },
          { title: 'Elite Stylist', price: '$300+' },
          { title: 'Master Stylist', price: '$290+' },
          { title: 'Stylist', price: '$280+' },
        ].map((item, i) => (
          <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
            <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
            <div className="flex-1 h-px bg-gray-300"></div>
            <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
          </div>
        ))}
      </div>

      {/* LUXE HIGHLIGHT / BALAYAGE */}
      <div className="mt-8 lg:mt-10">
        <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-3 text-left">
          Luxe Highlight / Balayage
        </h3>
        <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat] mb-4 text-left">
          <span className="font-semibold">Luxe Highlight / Balayage</span>  includes foils to create a lightened effect on 
          <span className="font-semibold "> 70% OR MORE OF YOUR HAIR</span>. This service also includes a 
          <span className="font-semibold"> B3 Bond Builder</span> in your formula, a 
          <span className="font-semibold"> Glaze</span> or <span className="font-semibold">Root Shadow</span>, and a 
          <span className="font-semibold"> Blow-dry</span>. This service gives you maximum color change.
        </p>
        {[
          { title: 'Artistic Director', price: '$450+' },
          { title: 'Senior Elite Stylist', price: '$425+' },
          { title: 'Elite Stylist', price: '$400+' },
          { title: 'Master Stylist', price: '$390+' },
          { title: 'Stylist', price: '$380+' },
        ].map((item, i) => (
          <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
            <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
            <div className="flex-1 h-px bg-gray-300"></div>
            <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
          </div>
        ))}
      </div>

      {/* PARTIAL HIGHLIGHTS */}
      <div className="mt-8 lg:mt-10">
        <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-3 text-left">
          Bleach and Tone Touch up
        </h3>
        {/* <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat] mb-4 text-left">
          <span className="font-semibold">Partial Highlights</span> typically includes 20 or less foils, to add a bit of dimension and brightening.
          This service also includes a <span className="font-semibold">Glaze</span> and a <span className="font-semibold">Blow-dry</span>.
        </p> */}
        {[
          { title: 'Artistic Director', price: 'N/A' },
          { title: 'Senior Elite Stylist', price: 'N/A' },
          { title: 'Elite Stylist', price: '$350+' },
          { title: 'Master Stylist', price: '$275+' },
          { title: 'Stylist', price: 'N/A' },
        ].map((item, i) => (
          <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
            <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
            <div className="flex-1 h-px bg-gray-300"></div>
            <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
          </div>
        ))}
      </div>

      {/* MONEY PIECE HIGHLIGHT */}
      <div className="mt-8 lg:mt-10">
        <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-3 text-left">
          Goldwell Gloss or Glaze 
        </h3>
        {/* <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat] mb-4 text-left">
          <span className="font-semibold">Money Piece Highlight</span> includes 10 or less foils to brighten and frame your face. This service also includes a 
          <span className="font-semibold"> Glaze</span> and a <span className="font-semibold">Blow-dry</span>.
        </p> */}
        {[
          { title: 'Artistic Director', price: '$150+' },
          { title: 'Senior Elite Stylist', price: '$150+' },
          { title: 'Elite Stylist', price: '$150+' },
          { title: 'Master Stylist', price: '$140+' },
          { title: 'Stylist', price: '$130+' },
        ].map((item, i) => (
          <div className="flex items-center gap-2 sm:gap-4 mb-3" key={i}>
            <span className="text-xs sm:text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">{item.title}</span>
            <div className="flex-1 h-px bg-gray-300"></div>
            <span className="text-xs sm:text-sm font-[Montserrat] text-[#C7A064]">{item.price}</span>
          </div>
        ))}
      </div>

      {/* VIVID / FASHION - Only in left column */}
      <div className="mt-8 lg:mt-10 lg:col-span-1">
        <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-3 text-left">
          Vivid / Fashion
        </h3>
        <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat] mb-3 text-left">
          <span className="font-semibold">Vivid / Fashion Color</span> is the most creative artistic expression. This consists of bright colors painted on
          pre-lightened hair for endless color combinations! Please come in for a consultation if you are interested
          in pricing. There is really no way to pin down a vivid color price on here as the possibilities are endless!
        </p>
        <p className="text-xs sm:text-sm font-bold text-gray-800 font-[Montserrat] text-left">
          WE LOVE VIVIDS!
        </p>
      </div>

      {/* Empty div to maintain grid layout */}
      <div className="mt-8 lg:mt-10 lg:col-span-1"></div>

    </div>

    {/* NOTE */}
    <div className="mt-10 text-center">
      <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat]">
        To provide the highest level of artistry not all stylist offer every service. Please review your stylist portfolio before booking.
      </p>
    </div>
  </div>
</section>

{/* ---------- LUXURY EXTENSIONS & SMOOTHING SERVICES ---------- */}
<section className="pt-8 sm:pt-12 md:pt-16 lg:pt-20 bg-[#FBF8F3]">
  <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 max-w-7xl">
    
    {/* LUXURY EXTENSIONS */}
    <div className="mb-16">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-wider font-[Montserrat] mb-10 text-center">
        Luxury Extensions
      </h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
        {/* Images Container - Spans 2 columns on large screens */}
        <div className="lg:col-span-2 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center sm:items-start">
          <div className="w-full sm:w-1/2 max-w-[300px] mx-auto sm:mx-0">
            <img src="/images/servicePage/extension_2.png" alt="Hair Extensions Service" className="w-full h-auto object-cover" />
          </div>
          <div className="w-full sm:w-1/2 max-w-[300px] mx-auto sm:mx-0">
            <img src="/images/servicePage/extension_1.png" alt="Hair Extensions Result" className="w-full h-auto object-cover" />
          </div>
        </div>
        
        {/* Text Content - Left aligned */}
        <div className="lg:col-span-1 text-left">
          <p
            className="text-xl md:text-2xl lg:text-[28px] mb-6"
            style={{
              color: '#000',
              fontFamily: 'Montserrat',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: 'normal',
              textTransform: 'uppercase'
            }}
          >
            We offer a variety of extension methods:
          </p>
          <ul className="space-y-3 mb-6">
            <li style={{
              color: '#000',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '100%',
              letterSpacing: '0.8px',
              textTransform: 'uppercase'
            }}>+ BUTTERFLY WEFT</li>
            <li style={{
              color: '#000',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '100%',
              letterSpacing: '0.8px',
              textTransform: 'uppercase'
            }}>+ Single Strand Flat Tip</li>
            <li style={{
              color: '#000',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '100%',
              letterSpacing: '0.8px',
              textTransform: 'uppercase'
            }}>+ Tape-Ins</li>
            <li style={{
              color: '#000',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '100%',
              letterSpacing: '0.8px',
              textTransform: 'uppercase'
            }}>+ K-Tip Extensions</li>
          </ul>
          <p className="text-sm text-gray-600 font-[Montserrat] mb-6">
            We proudly carry <span className="font-semibold">Malia, Aqua</span>, and <span className="font-semibold">Remi Cachet</span> extensions.
          </p>
          <p className="text-sm text-gray-600 font-[Montserrat] mb-6">
            Please see one your extension specialists for a consultation and pricing.
          </p>
          <a 
            href="/Gallery" 
            className="text-[#C7A064] text-sm font-semibold uppercase tracking-wider font-[Montserrat] hover:text-[#B08D57] transition-colors"
          >
            View Our Creations
          </a>
        </div>
      </div>
    </div>
    
    {/* SMOOTHING SERVICES */}
    <div className="mb-0">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-wider font-[Montserrat] mb-6 text-center">
        Smoothing Services
      </h2>
      <p className="text-sm text-[#C7A064] font-[Montserrat] normal text-center mb-10">
        Pricing varies based on length and thickness of your hair.
      </p>
      {/* Brazilian Blowout - Left aligned in container */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-x-16 xl:gap-x-24">
        <div>
          <h3 className="text-lg font-bold uppercase font-[Montserrat] mb-6 text-left">
            Brazilian Blowout
          </h3>
          {[
            { title: 'Artistic Director', price: 'N/A' },
            { title: 'Senior Elite Stylist', price: '$425+' },
            { title: 'Elite Stylist', price: '$425+' },
            { title: 'Master Stylist', price: '$350+' },
            { title: 'Stylist', price: '$325+' },
          ].map((item, i) => (
            <div className="flex items-center gap-4 mb-4" key={i}>
              <span className="text-sm uppercase font-medium font-[Montserrat] whitespace-nowrap">
                {item.title}
              </span>
              <div className="flex-1 h-px bg-gray-300"></div>
              <span className={`text-sm font-[Montserrat] ${item.price === 'N/A' ? 'text-[#C7A064]' : 'text-[#C7A064]'}`}>
                {item.price}
              </span>
            </div>
          ))}
        </div>
        {/* Empty div to maintain grid layout */}
        <div></div>
      </div>
      {/* Bottom Note */}
      <div className="mt-12 text-center pb-16">
        <p className="text-xs sm:text-sm text-gray-600 font-[Montserrat]">
          To provide the highest level of artistry not all stylist offer every service. Please review your stylist portfolio before booking.
        </p>
      </div>
    </div>
  </div>
  
  {/* Disclaimer Section - Full Width Outside Container */}
  <div className="w-full bg-[#F2EADC] pt-10 sm:pt-12 pb-0">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-10 sm:pb-12">
      <p className="text-center text-sm sm:text-base text-gray-700 font-[Montserrat] leading-relaxed">
       We aim to keep our pricing, accurate and up-to-date. All prices listed here are estimates. FINAL PRICING will be determined by consultation or an on person visit. Final pricing is determined by the length and thickness of your hair. If you have any questions feel free to  {' '}
        <a href="tel:+16109233530" className="text-[#C7A064] hover:underline font-medium">
           call
        </a>{' '}
        or ask during your consultation. Gratuities not included.
      </p>
    </div>
  </div>
</section>
    </>
  );
};

export default PricingSection;